import { render, staticRenderFns } from "./cartNotification.vue?vue&type=template&id=f4d080ca&scoped=true&"
import script from "./cartNotification.vue?vue&type=script&lang=js&"
export * from "./cartNotification.vue?vue&type=script&lang=js&"
import style0 from "./cartNotification.vue?vue&type=style&index=0&id=f4d080ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4d080ca",
  null
  
)

export default component.exports